import { useQuery } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { ITeamMembersResponse } from "../../features/Configurations/TeamManagement/interface";

export const useTeamMembers = (params: { page: number; per_page: number }) => {
  return useQuery({
    queryKey: ["team-members", params],
    queryFn: async () => {
      const response = await httpService.get<ITeamMembersResponse>(
        API_CONFIG.path.teamMembers,
        params
      );
      return response;
    },
  });
};
